<template>
    <div class="card rounded-lg" style="overflow: hidden;">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
                <div>{{ $t('notifications') }}</div>
<!--                <div>{{ notifications.length }}</div>-->
            </div>
        </div>
        <div class="card-body p-0">
            <div class="d-flex flex-column scroll-y custom-scrollbar" style="max-height: 380px;">
                <div class="py-2 px-3 notification" v-for="(item, index) in notifications" :key="`notification-${index}-${item.id}`">
                    <img width="24" height="24" class="rounded-circle" :src="item?.profile_picture?.full_url || urlGenerator('/images/avatar-demo.jpg')" alt="">
                    <small class="text-muted">{{ item.data.message }}</small>
                </div>
                <div v-if="!notifications.length">
                    <app-empty-data-block message=""/>
                </div>
            </div>
            <button v-if="!no_more" class="btn btn-link w-100" @click="getNotification">{{ $t('more') }}</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {NOTIFICATIONS} from "../../../../../config/ApiUrl";
import {urlGenerator} from "../../../../../helpers/AxiosHelper";

export default {
    data() {
        return {
            urlGenerator,
            params: {
                page: 1,
                per_page: 20,
                order_by: 'desc'
            },
            notifications: [],
            no_more: false,
            loading: false
        }
    },
    methods: {
        getNotification(loading = false) {
            if (!this.no_more) {
                this.loading = loading
                axios.get(urlGenerator(NOTIFICATIONS), {params: this.params}).then(res => {
                    this.notifications = [...this.notifications, ...res.data.data]
                    if (this.params.page === res.data.last_page) this.no_more = true
                    else this.params.page += 1
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    },
    created() {
        this.getNotification(true)
    }
}
</script>

<style scoped lang="scss">
.notification{
    &:hover{
        background-color: #dddddd50;
        color: #000 !important;
    }
}

</style>